module.exports = __webpack_public_path__ + "static/media/0520-s-l-en.89b18275.png";